import { ContactPerson, Organization } from '@iss/libs/graphql';
import { FormArray, FormGroup, Validators } from '@angular/forms';

import { ContactPersonControls, ContactPersonFormGroup } from './contact-person-form.group';

import { DeepPartial } from '@iss/wo-common/types';

export class ContactPeopleFormArray extends FormArray<FormGroup<ContactPersonControls>> {
  public newItemValue?: DeepPartial<ContactPerson>;
  public requiredRoles!: readonly string[];

  public static create(
    value?: DeepPartial<Organization['contactPeople']>,
    newItemValue?: DeepPartial<ContactPerson>,
    requiredRoles?: readonly string[],
  ): ContactPeopleFormArray {
    const restored = value?.map(person => ContactPersonFormGroup.create(person)) || [];

    const missingRequired = requiredRoles
      ?.filter(role => !restored.find(i => i.value.role === role))
      ?.map(role => ContactPersonFormGroup.create({ ...(newItemValue || {}), role })) || [];

    const required = [ ...missingRequired, ...restored ];

    const items = required.length === 0 ? [ ContactPersonFormGroup.create(newItemValue) ] : required;

    const instance = new this(items, { validators: [ Validators.min(1), Validators.max(10) ] });

    instance.newItemValue = newItemValue;
    instance.requiredRoles = requiredRoles || [];

    return instance;
  }

  public add(): void {
    this.push(ContactPersonFormGroup.create(this.newItemValue));
  }

  public canAdd(): boolean {
    return this.length < 10;
  }

  public canRemove(index: number): boolean {
    if (this.length < 2) {
      return false;
    }

    const role = this.controls.at(index)?.value.role;
    return !role || !this.requiredRoles.includes(role) || this.countItems(role) > 1;
  }

  public isRoleDisabled(index: number): boolean {
    const role = this.controls.at(index)?.value.role;
    return !(role && this.countItems(role) > 1);
  }

  private countItems(role: string): number {
    return this.value.filter(i => i.role === role).length;
  }
}
